import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {ConservazioneCaricaDocumentoFormularioIdentificativoRifiutiStep2Component
} from './conservazione-carica-documento-formulario-identificativo-rifiuti-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-formulario-identificativo-rifiuti-step2', {
            url: '/conservazione-carica-formulario-identificativo-rifiuti',
            ncyBreadcrumb: {
                label: 'Carica Formulario Identificativo Rifiuti',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-formulario-identificativo-rifiuti-step2 flex="100"></conservazione-carica-documento-formulario-identificativo-rifiuti-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoFormularioIdentificativoRifiutiStep2Module: string = ng
    .module('conservazione-carica-documento-formulario-identificativo-rifiuti-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoFormularioIdentificativoRifiutiStep2', ConservazioneCaricaDocumentoFormularioIdentificativoRifiutiStep2Component)
    .config(stateConfig)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-formulario-identificativo-rifiuti-step2/conservazione-carica-documento-formulario-identificativo-rifiuti-step2.module.ts